import { Pipe, PipeTransform } from '@angular/core';
import { KnxNameKind, knxName } from './knx-names';

/**
 * KNX room / floor / device name for the UI language: `{{ d.name | knxName:lang:'device' }}`.
 * Pure: pass the component's current language (updated on TranslateService.onLangChange) so a
 * language switch re-evaluates it. null / undefined stay null, so `??` fallbacks keep working.
 */
@Pipe({ name: 'knxName' })
export class KnxNamePipe implements PipeTransform {
  transform(value: string, lang: string | null | undefined, kind: KnxNameKind): string;
  transform(value: string | null | undefined, lang: string | null | undefined, kind: KnxNameKind): string | null;
  transform(value: string | null | undefined, lang: string | null | undefined, kind: KnxNameKind): string | null {
    return value == null ? null : knxName(value, lang, kind);
  }
}
